<template>
  <div class="c-box">
    <inactive-alert v-if="form.is_active === false" />
    <form-wrapper
      ref="form"
      :service="Lecturer"
      :formComponent="InnerForm"
      :form.sync="form"
      :errors.sync="errors"
      :objParams="$route.params.lecturerId"
    />
    <a-divider />
    <div class="actions" v-if="form.id">
      <a-button
        class="margin-right-15"
        v-if="form.is_active === true"
        @click="deactivateConfirm"
        >Dezaktywuj konto</a-button
      >
      <a-button
        class="margin-right-15"
        v-else-if="form.is_active === false"
        @click="activate"
        >Aktywuj konto</a-button
      >
      <a-button
        class="margin-right-15"
        v-if="form.id"
        type="danger"
        @click="deleteConfirm"
      >
        Usuń konto
      </a-button>
    </div>
  </div>
</template>
<script>
import { Lecturer } from '@/api'
import InnerForm from '@/components/forms/LecturerForm'
import InactiveAlert from './InactiveAlert'

export default {
  components: {
    InactiveAlert
  },
  data() {
    return {
      form: {},
      errors: {},
      Lecturer,
      InnerForm
    }
  },
  methods: {
    deleteConfirm() {
      this.$confirm({
        title: 'Usuń konto lektora',
        maskClosable: true,
        content:
          'Przypisane dostępności oraz rezerwacje zostaną anulowane. Kursanci zostaną poinformowani o anulowanych rezerwacjach.',
        okText: 'Usuń',
        cancelText: 'Anuluj',
        onOk: () => {
          this.delete()
        }
      })
    },
    deactivateConfirm() {
      this.$confirm({
        title: 'Dezaktywuj konto lektora',
        maskClosable: true,
        content:
          'Przypisane dostępności oraz rezerwacje zostaną anulowane. Kursanci zostaną poinformowani o anulowanych rezerwacjach.',
        okText: 'Dezaktywuj',
        cancelText: 'Anuluj',
        onOk: () => {
          this.deactivate()
        }
      })
    },
    delete() {
      this.loading = true
      Lecturer.delete(this.form.id)
        .then(() => {
          this.$refs.form.isDirty = false
          this.$notification.success({ message: 'Usunięto konto.' })
          this.$router.push('/admin/lektorzy')
        })
        .finally(() => {
          this.loading = false
        })
    },
    deactivate() {
      this.loading = true
      Lecturer.deactivate(this.form.id)
        .then(() => {
          this.$notification.success({ message: 'Konto dezaktywowane' })
          this.$refs.form.fetchData()
        })
        .finally(() => {
          this.loading = false
        })
    },
    activate() {
      this.loading = true
      Lecturer.activate(this.form.id)
        .then(() => {
          this.$notification.success({ message: 'Konto aktywowane' })
          this.$refs.form.fetchData()
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
